<script setup lang="ts">
defineExpose({
  name: "RadioOnIcon",
});
</script>

<template>
  <svg
    class="RadioOnIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="RadioOnIcon__inner"
      cx="12"
      cy="12"
      r="7.375"
      stroke-width="1.25"
    />
    <circle class="RadioOnIcon__inner" cx="12" cy="12" r="5" />
  </svg>
</template>

<style lang="scss" scoped>
.RadioOnIcon {
  width: 100%;
  height: auto;

  &__inner {
    &:first-child {
      stroke: currentcolor;
    }

    &:nth-child(2) {
      fill: currentcolor;
    }
  }
}
</style>
